import { mainColor } from '../../constants';

const styles = {
  iconStyle: {
    color: mainColor.iconColor
  }
};

export default styles;
